import type { EligibilityArea } from '../../types/apiModels'
import { apiClient } from './client'
import endpoints from './endpoints'
import type { ApiV2QueryType } from './types'
import { unwrapPaginated, type Paginated } from './normalize'

// `create` is deliberately absent: that branch answers a message-only envelope and lives in
// createEligibilityCheck, so the read query type cannot express it.
export type EligibilityCheckQueryPayload = {
  forceDetection?: boolean
  filterAreas?: string
}

export type EligibilityCheckQuery = ApiV2QueryType<EligibilityCheckQueryPayload>

// The payload only lists non-empty areas, so a check that ran and found nothing is
// indistinguishable from one that never ran without this flag.
export type EligibilityCheckMeta = {
  hasEligibilityCheck: boolean
}

type GetEligibilityCheckArgs = {
  farmId: string
  query?: EligibilityCheckQuery
  signal?: AbortSignal
}

export const getEligibilityCheckWithMeta = async ({
  farmId,
  query,
  signal,
}: GetEligibilityCheckArgs): Promise<Paginated<EligibilityArea, EligibilityCheckMeta>> => {
  const response = await apiClient.get(endpoints.v2.farms.eligibilityCheck(farmId), {
    params: query,
    signal,
  })
  return unwrapPaginated<EligibilityArea, EligibilityCheckMeta>(response)
}

export default async function getEligibilityCheck(
  args: GetEligibilityCheckArgs,
): Promise<EligibilityArea[]> {
  const { items } = await getEligibilityCheckWithMeta(args)
  return items
}
